import { IFairnessState } from "~/features/Fairness/store/types";
import { EFairnessTypes, ESchedulesCount } from "~/features/Fairness/types";

export const initialState: IFairnessState = {
  fairnessType: EFairnessTypes.preferencesHonored,
  schedulesCount: ESchedulesCount.last6,
};
